import { render } from "./HeaderPixParcelado.vue?vue&type=template&id=423a6e36&scoped=true"
import script from "./HeaderPixParcelado.vue?vue&type=script&lang=js"
export * from "./HeaderPixParcelado.vue?vue&type=script&lang=js"

import "./HeaderPixParcelado.vue?vue&type=style&index=0&id=423a6e36&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423a6e36"]])

export default __exports__